// Copyright 2021 Pangea Cyber Corporation
// Author: Pangea Cyber Corporation
import { __spreadArray } from "tslib";
import create from "zustand";
import uniqBy from "lodash/uniqBy";
import { parseErrorFromPangea } from "../../utils";
export var useAlerts = create(function (set, get) { return ({
    alerts: [],
}); });
export var showAlert = function (message, options) {
    var _a = (options !== null && options !== void 0 ? options : {}).severity, severity = _a === void 0 ? "error" : _a;
    if (!message)
        return;
    useAlerts.setState(function (state) { return ({
        alerts: uniqBy(__spreadArray(__spreadArray([], state.alerts, true), [{ message: message, severity: severity }], false), "message"),
    }); });
};
export var alertOnError = function (error) {
    console.error(error);
    showAlert(parseErrorFromPangea(error));
};
export var clearAlerts = function () {
    useAlerts.setState(function () { return ({ alerts: [] }); });
};
